import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const SortingOff = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function SortingOff({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M11.7908 3.78871V20.5C11.7908 20.7761 11.5669 21 11.2908 21H10.7996C10.5234 21 10.2996 20.7761 10.2996 20.5V5.41277L4.47559 11.6551C4.28657 11.8577 3.96884 11.8679 3.76715 11.6779L3.40715 11.3388C3.20684 11.1501 3.19667 10.835 3.38441 10.6337L10.1384 3.39466C10.5336 2.97101 11.0453 2.88843 11.4859 3.14695C11.7043 3.27509 11.7908 3.53549 11.7908 3.78871Z'
        fill={color}
      />
      <path
        d='M13.2913 20.2113V3.5C13.2913 3.22386 13.5151 3 13.7913 3H14.2825C14.5586 3 14.7825 3.22386 14.7825 3.5V18.5872L20.6064 12.3449C20.7955 12.1423 21.1132 12.1321 21.3149 12.3221L21.6749 12.6612C21.8752 12.8499 21.8854 13.165 21.6976 13.3663L14.9437 20.6053C14.5484 21.029 14.0367 21.1116 13.5961 20.8531C13.3777 20.7249 13.2913 20.4645 13.2913 20.2113Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'sorting-off-icon-svg'} iconRender={iconRender} {...props} />;
});

export default SortingOff;
